import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './local';

// Lấy ngôn ngữ từ localStorage hoặc mặc định là 'vi'
const savedLanguage = localStorage.getItem('language') || 'vi';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: ['vi', 'en'],
    interpolation: {
      escapeValue: false,
    },
  });

// Lưu ngôn ngữ vào localStorage khi thay đổi
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;